<template>
  <v-dialog
    v-model="dialog"
    width="1200px">
    <div class="dialog-container">
      <h2>Transfer All Funds To Another Ticket</h2>
      <div class="abs-top-right">
        <v-button @click="dialog = false">Cancel</v-button>
        <v-button
          type="primary"
          @click="handlerSave">Transfer</v-button>
      </div>
      <div class="filter-container">
        <div class="form-item">
          <span>Search</span>
          <v-input
            v-model="search"
            @keyEnter="filterData"
          />
        </div>
        <div class="form-item">
          <span>Created On</span>
          <v-date-picker
            v-model="date"
            type="range"
            @change="filterData"
          />
        </div>
      </div>
      <div class="transparent">
        <el-table
          :data="tableData"
          stripe
          style="width: 100%"
          @row-click="rowClick">
          <el-table-column width="55">
            <template slot-scope="scope">
              <span
                :class="[selectCustomerIndex == scope.$index? 'radio-circle-checked': 'radio-circle' ]"
              ></span>
            </template>
          </el-table-column>
          <el-table-column
            prop="id"
            label="ID"></el-table-column>
          <el-table-column
            prop="subject"
            label="Subject"></el-table-column>
          <el-table-column
            prop="requester"
            label="Requester"></el-table-column>
          <el-table-column
            prop="created_at"
            label="Created On"></el-table-column>
          <el-table-column
            label="Type">
            <template slot-scope="scope">
              <span class="span-checkbox">{{ scope.row.type_language }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="assignee"
            label="Assigned To"></el-table-column>
        </el-table>
      </div>

      <v-pagination
        :total="pageConfig.total"
        :current="pageConfig.currentPage"
        @currentChange="currentChange"
      />
    </div>
  </v-dialog>
</template>
<script>
import MixinOptions from '@/mixins/options'
export default {
  name: 'TransferFunds',
  mixins: [MixinOptions],
  data() {
    return {
      dialog: false,
      pageConfig: {
        //  分頁配置
        currentPage: 1,
        total: 10
      },
      date: [],
      search: '',
      tableData: [],
      selectCustomerIndex: -1
    }
  },
  watch: {
    property: {
      immediate: true,
      handler() {
        // this.network().getCustomerList()
      }
    }
  },
  methods: {
    handlerSave() {
      if(this.selectCustomerIndex !== -1) {
        // this.network().chooseTicketCustomer()
      }
    },
    changeDialog() {
      this.dialog = !this.dialog
    },
    rowClick(row) {
      const { index } = row
      this.selectCustomerIndex = index
    },
    filterData() {
      this.pageConfig.currentPage = 1
    //   this.network().getCustomerList()
    },
    currentChange(page) {
      this.pageConfig.currentPage = page
    //   this.network().getCustomerList()
    },
    network() {
      return {
        getCustomerList: async () => {
          let { data } = await getCustomerList({
            type: this.type,
            search: this.search,
            page: this.pageConfig.currentPage,
            hideLoading: true,
          })
          data.data.map((item, index) => {
            item.index = index
            return item
          })
          this.tableData = data.data
          this.pageConfig.total = data.total
          this.selectCustomerIndex = -1
        },
        chooseTicketCustomer: async () => {
          const { data } = await chooseTicketCustomer({
            ticket_id: this.ticketId,
            customer_id: this.tableData[this.selectCustomerIndex].id
          })
          // this.$message({
          //   type: 'success',
          //   message: 'Success'
          // })
          this.dialog = false
          this.$emit('success')
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-container {
    position: relative;
  padding: 15px;
  .abs-top-right {
      padding: 20px 15px;
  }
  .radio-circle {
    display: inline-block;
    //   box-sizing: border-box;
    width: 14px;
    height: 14px;
    border-radius: 100%;
    border: 1px solid #d5d8de;
    background: white;
    cursor: pointer;
  }
  .radio-circle-checked {
    position: relative;
    display: inline-block;
    //   box-sizing: border-box;
    width: 14px;
    height: 14px;
    border-radius: 100%;
    background: #409eff;
    &::before {
      position: absolute;
      content: "";
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 5px;
      height: 5px;
      border-radius: 100%;
      background: white;
    }
  }
  .filter-container {
    display: flex;
    align-items: center;
    margin: 0 auto 20px 0;
    .form-item {
        margin-right: 15px;
        width: 400px;
    }
  }
}
</style>